export default {
    created () {
        document.title = 'Conversific - Business Intelligence Platform'
    }
}